/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  display: inline-block;
  vertical-align: middle;
  contain: content;
  cursor: pointer;
}

.link {
  text-decoration: none;
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  padding: calc(6rem /14) 0;
}
.link davinci-icon-ref,
.link davinci-icon {
  font-size: 1rem;
  width: calc(18rem /14);
  display: inline-block;
  margin-top: calc(-2rem /14);
}
.link .text {
  display: inline-block;
  line-height: calc(18rem /14);
}
:host([inside-text]) .link {
  padding: 0;
}

:host([inverted]) .link {
  background-color: #737F85;
  background-color: var(--davinci-color-secondary, #737F85);
  color: #FFFFFF;
  color: var(--davinci-color-text-on-secondary, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary, #FFFFFF);
  padding: calc(6rem /14);
}

:host([inverted][inside-text]) .link {
  padding: 0 calc(6rem /14);
}

.link:visited davinci-icon-ref,
.link:visited davinci-icon {
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host([inverted]) .link:visited davinci-icon-ref,
:host([inverted]) .link:visited davinci-icon {
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary, #FFFFFF);
}

.link:visited .text {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
:host([inverted]) .link:visited .text {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-secondary, #FFFFFF);
}

.link:active .text {
  color: #005B8E;
  color: var(--davinci-color-primary-dark, #005B8E);
}
:host([inverted]) .link:active .text {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-secondary-light, #FFFFFF);
}

:host([inverted]) .link:hover {
  background-color: #8E989D;
  background-color: var(--davinci-color-secondary-light, #8E989D);
}

.link:hover davinci-icon-ref,
.link:hover davinci-icon {
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}
.link:hover .text {
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
}
:host([inverted]) .link:hover .text {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-secondary-light, #FFFFFF);
}

:host(:not([icon])) {
  vertical-align: text-top;
}
:host(:not([icon])) davinci-icon {
  display: none;
}

:host([disabled][inverted]),
:host([disabled]) {
  pointer-events: none;
  cursor: default;
}
:host([disabled][inverted]) .link,
:host([disabled]) .link {
  background-color: unset;
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled][inverted]) .link .text,
:host([disabled]) .link .text {
  background-color: unset;
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled][inverted]) davinci-icon-ref,
:host([disabled][inverted]) davinci-icon,
:host([disabled]) davinci-icon-ref,
:host([disabled]) davinci-icon {
  fill: #C5CACC;
  fill: var(--davinci-color-outline-light, #C5CACC);
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled][inverted]) .text,
:host([disabled]) .text {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
